module.exports = __webpack_public_path__ + "static/image/history/pc/202305.jpg?dacd10c0";